import React from 'react';

const Label = ({ htmlFor, children, className, ...props }) => {
  return (
    <label
      htmlFor={htmlFor}
      className={`label
        text-azul-lago
        font-semibold
        text-sm
        mb-2
        block
        ${className}`}
      {...props}
    >
      {children}
    </label>
  );
};

export default Label;
